import script from "./Nationality.vue?vue&type=script&setup=true&lang=js"
export * from "./Nationality.vue?vue&type=script&setup=true&lang=js"

import "./Nationality.vue?vue&type=style&index=0&id=70f944ca&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/barmm-admin-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70f944ca"]])

export default __exports__